export default __webpack_public_path__ + "static/media/ge.9a1cd82f.jpg";